/** @file Deflate's match copy: `length` bytes from `distance` back, an overlap repeating the pattern. */

/**
 * Copies `length` bytes from `distance` back to `w` in `out`; an overlap repeats the pattern, as deflate requires. Short
 * matches go byte by byte; long ones in copyWithin steps that double while the copied run stays a whole number of
 * periods (`distance`), so the source is always already written. The caller checks both ends against `out`.
 */
export function copyBack(out: Uint8Array, w: number, distance: number, length: number): void {
  if (length < 32) {
    for (let k = w; k < w + length; k++) out[k] = out[k - distance] ?? 0;
    return;
  }
  for (let done = 0; done < length; ) {
    const n = Math.min(length - done, distance + done);
    out.copyWithin(w + done, w - distance, w - distance + n);
    done += n;
  }
}
